<template>
	<div>
		<BaseAccordionController :accordion_header="getStateWithParam('contact')">
			<template v-slot:component>
				<component :is="contactBashkia" class="accordion-card-middle"></component>
			</template>
		</BaseAccordionController>

		<BaseAccordionController :accordion_header="companiesTitleHeader">
			<template v-slot:component>
				<!-- <component
					:is="tableCardVue"
					:data_temp="data_temp"
					:info_header="info_header"
					class="accordion-card-middle"
				></component> -->
				<v-list three-line class="companies-list">
					<template v-for="(item, index) in data_temp">
						<v-divider
							:key="'divider-'+index"
							:inset="item.inset"
						></v-divider>
						<v-list-tile
							:key="'item-'+index"
						>
							<v-list-tile-content>
								<v-list-tile-title v-html="item.emri"></v-list-tile-title>
								<v-list-tile-sub-title>
									<div class="d-inline-flex">
										<v-icon small class="mr-1">place</v-icon>
										<span>{{item.adresa}}</span>
									</div>
								</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</template>
				</v-list>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import ContactBashkia from "@/components/cards/ContactBashkiaCard.vue";
import TableCard from "@/components/cards/TableCard.vue";
import info from "@/config/api/api_events/info.js";

export default {
  	name: "Companies",
	components: {
		TableCard
	},
	data() {
		return {
			data_temp: [],
			info_header: [],
			tableCardVue: TableCard,
			contactBashkia: ContactBashkia,
			contactBashkiaTitleHeader: this.getStateWithParam("contact"),
			companiesTitleHeader: this.getStateWithParam("label_info_enterprise")
		};
	},
  	created(){
		this.getNdermarrjetFromCall();
	},
	methods: {
		getNdermarrjetFromCall() {
			info
			.getNdermarrjet()
			.then(response => {
				this.$store.state.active_loader = false;
				this.info_header = response.colona.map(el => {
					return {
					text: el,
					value: el,
					align: el == "emri" ? "left" : "right",
					sortable: true
					};
				});
				this.data_temp = response.lista;
			})
			.catch(error => {
				this.$store.state.active_loader = false;
				console.log("There was an error:", error);
			});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		}
	},
};
</script>

<style lang="scss">
.companies-list{
	.v-list__tile{
		height: auto !important;
		padding-top: 15px;
		padding-bottom: 10px;
	}
	.v-list__tile__title, .v-list__tile__sub-title{
		white-space: normal;
		overflow: visible;
		height: auto;
		line-height: 1.2;
	}
	.v-list__tile__sub-title{
		margin-top: 8px;
	}
}
</style>
